(function ($) {

    function detectionIEVersion() {
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf('MSIE ');
        if (msie > 0) {
            // IE 10 or older, return version number 
            return ('IE ' + parseInt(ua.substring(
                msie + 5, ua.indexOf('.', msie)), 10));
        }
        var trident = ua.indexOf('Trident/');
        if (trident > 0) {
            // IE 11, return version number 
            var rv = ua.indexOf('rv:');
            return ('IE ' + parseInt(ua.substring(
                rv + 3, ua.indexOf('.', rv)), 10));
        }
        var edge = ua.indexOf('Edge/');
        if (edge > 0) {
            //Edge (IE 12+), return version number 
            return ('IE ' + parseInt(ua.substring(
                edge + 5, ua.indexOf('.', edge)), 10));
        }
        // User uses other browser 
        return ('Not IE');
    }

    if (!window.a8bot.cusInfo) {
        return;
    } else {
        // console.log("Chat App Config: ", JSON.stringify(window.a8bot.appConfig));
        var botHandle = window.a8bot.cusInfo.botHandle;

        function isChatLoad() {
            var chatInfo = null;
            if (localStorage.a8bot_sto && botHandle) {
                chatInfo = JSON.parse(localStorage.a8bot_sto);
                if (chatInfo.botHandles && chatInfo.botHandles[botHandle] && chatInfo.botHandles[botHandle].selectedTopics) {
                    for (var topicID in chatInfo.botHandles[botHandle].selectedTopics) {
                        if (typeof chatInfo.botHandles[botHandle].selectedTopics[topicID] != "string" && chatInfo.botHandles[botHandle].selectedTopics[topicID].chatId == null) {
                            delete localStorage.a8bot_sto;
                        }
                    }
                } else {
                    delete localStorage.a8bot_sto;
                }
            } else {
                delete localStorage.a8bot_sto;
            }
        }

        isChatLoad();
        window.a8bot.cusInfo.userId = window.a8bot.cusInfo.userId || new Date().getTime().toString();
        var a8bot_sto = {
            botHandles: {}
        };
        if (localStorage.a8bot_sto) {
            a8bot_sto = JSON.parse(localStorage.a8bot_sto);
        }
        if (!sessionStorage.mqttClientId) {
            sessionStorage.mqttClientId = uuidv4('MQTT');
        }
        if (a8bot_sto && a8bot_sto.botHandles) {
            if (!a8bot_sto.botHandles[botHandle] || a8bot_sto.botHandles[botHandle].userId != window.a8bot.cusInfo.userId) {
                a8bot_sto.botHandles[botHandle] = {
                    userId: null,
                    clientId: null,
                    selectedTopics: null,
                    msgInQueue: 0
                };
            }
            // delete sessionStorage.userId;
            // delete sessionStorage.clientId;
            // delete sessionStorage.userId;
            // delete sessionStorage.selectedTopics;
            // delete sessionStorage.msgInQueue;
        }
        a8bot_sto.botHandles[botHandle].userId = window.a8bot.cusInfo.userId;
        localStorage.a8bot_sto = JSON.stringify(a8bot_sto);
        window.a8bot.domainURL = $("#a8_chat_widget").attr("src").replace('/hosted/widget.js', '');
        var render = window.document;
        var script = document.createElement("script");
        script.src = window.a8bot.domainURL + "/js/env.js";
        render.body.appendChild(script);
        script = document.createElement('script');
        script.src = window.a8bot.domainURL + "/lib/js/moment/moment.min.js";
        render.body.appendChild(script);
        script = document.createElement('script');
        script.src = window.a8bot.domainURL + "/lib/js/moment/moment-timezone-with-data.min.js";
        render.body.appendChild(script);
        script = document.createElement("script");
        script.src = window.a8bot.domainURL + "/app/common/config.js";
        render.body.appendChild(script);
        script = document.createElement('script');
        script.src = window.a8bot.domainURL + "/app/common/logger.js";
        render.body.appendChild(script);

        function checkBotConfigLoaded() {
            setTimeout(function () {
                try {
                    moment.tz.guess();
                } catch (e) {
                    console.error("Moment JS Loading Issues: ", e);
                    // location.reload();
                }
                if (window.baseURL && config && window.baseURL) {
                    if (!a8bot_sto.botHandles[botHandle].clientId) {
                        a8bot_sto.botHandles[botHandle].clientId = uuidv4("A8BOT");
                        localStorage.a8bot_sto = JSON.stringify(a8bot_sto);
                    }
                    var http = new XMLHttpRequest();
                    http.open(
                        "GET",
                        window.baseURL +
                        config.getConfig,
                        true
                    );
                    http.setRequestHeader("Content-type", "application/json;charset=UTF-8");
                    http.setRequestHeader("x-app-key", window.a8bot.cusInfo.appKey);
                    http.setRequestHeader("x-org-id", window.a8bot.cusInfo.orgId);
                    http.setRequestHeader("x-client-id", a8bot_sto.botHandles[botHandle].clientId);
                    http.setRequestHeader("x-bot-handle", window.a8bot.cusInfo.botHandle);
                    http.onreadystatechange = function () {
                        if (http.readyState == 4) {
                            if (http.status == 200) {
                                window.a8bot.configuration = JSON.parse(http.response).configuration;
                                //hold theme from client
                                window.a8bot.defaultTheme = window.a8bot.configuration.theme;
                                init();
                            } else if (http.status == 0) {
                                console.error("Unable get the app theme information");
                            }
                        }
                    };
                    http.send();
                } else {
                    checkBotConfigLoaded();
                }
            }, 2000);
        }

        function init() {
            if (!window.a8bot.helper) {
                window.a8bot.helper = {};
            }
            window.a8bot.helper = {
                showIcon: null,
                hideIcon: null,
                showNotification: null,
                closeNotification: null,
                chatOpen: null,
                chatClose: null
            }
            var render = window.document;
            var jqueryURL = window.a8bot.domainURL + "/lib/js/jquery/jquery-2.2.4.min.js";
            if (detectionIEVersion() != 'Not IE') {
                window.a8bot.isIE11 = detectionIEVersion() == 'IE 11';
                window.a8bot.isIE10 = detectionIEVersion() == 'IE 10';
            }

            function getTimezone() {
                if (window.a8bot.isIE10) {
                    return new Date().toTimeString();
                }
                return new Date().toString().match(/\(([A-Za-z\s].*)\)/)[1];
            }
            window.a8bot.cusInfo.timeZone = getTimezone();
            setTimeout(function () {
                $.getScript(jqueryURL, function () {
                    var head = document.getElementsByTagName('head')[0];

                    var link = document.createElement('link');
                    link.rel = 'stylesheet';
                    link.type = 'text/css';
                    link.href = window.a8bot.domainURL + '/lib/css/animate.css';
                    link.media = 'all';
                    head.appendChild(link);

                    var link = document.createElement('link');
                    link.rel = 'stylesheet';
                    link.type = 'text/css';
                    link.href = window.a8bot.domainURL + '/lib/fonts/fonts.css';
                    link.media = 'all';
                    head.appendChild(link);

                    var link = document.createElement('link');
                    link.rel = 'stylesheet';
                    link.type = 'text/css';
                    link.href = window.a8bot.domainURL + '/css/hosted.css';
                    link.media = 'all';
                    head.appendChild(link);

                    //attach custom font CDN from bot theme config
                    var link = document.createElement('link');
                    link.rel = 'stylesheet';
                    link.type = 'text/css';
                    link.href = window.a8bot.domainURL + '/lib/font-awesome/css/font-awesome.min.css';
                    link.media = 'all';
                    head.appendChild(link);

                    // attach theme middleware
                    var theme = document.createElement('script');
                    theme.src = window.a8bot.domainURL + "/hosted/theme/theme.middleware.v1.js";
                    render.body.appendChild(theme);

                    if (theme.readyState) { // only required for IE <9
                        theme.onreadystatechange = function () {
                            if (theme.readyState === "loaded" || theme.readyState === "complete") {
                                theme.onreadystatechange = null;
                                syncTabLoad();
                            }
                        };
                    } else { //Others
                        theme.onload = function () {
                            syncTabLoad();
                        };
                    }

                });
            }, window.a8bot.appConfig.initTime);
        }


        function syncTabLoad() {
            var checkParallelLoad = JSON.parse(localStorage.a8bot_sto);
            if (!checkParallelLoad.botHandles[botHandle].sequenceLoad) {
                a8bot_sto.botHandles[botHandle].sequenceLoad = true;
                localStorage.a8bot_sto = JSON.stringify(a8bot_sto);
                loadHostedJS();
            } else {
                setTimeout(function () {
                    var currentTopic = null;
                    if (checkParallelLoad.botHandles[botHandle].selectedTopics) {
                        currentTopic = checkParallelLoad.botHandles[botHandle].selectedTopics.current;
                        if (currentTopic && checkParallelLoad.botHandles[botHandle].selectedTopics[currentTopic]) {
                            if (checkParallelLoad.botHandles[botHandle].selectedTopics[currentTopic].chatId != null) {
                                // console.log(checkParallelLoad.botHandles[botHandle].selectedTopics[currentTopic].chatId, "Load The Next Process");
                                loadHostedJS();
                            } else {
                                syncTabLoad();
                            }
                        }
                    } else {
                        syncTabLoad();
                    }
                }, 1000);
            }
        }

        function loadHostedJS() {
            var hosted = document.createElement('script');
            hosted.src = window.a8bot.domainURL + "/hosted/hosted.js" //?timestamp=" + new Date().getTime();
            render.body.appendChild(hosted);
        }


        function generateUniqueId(prefix) {
            function rand() {
                return Math.floor((1 + Math.random()) * 0x10000)
                    .toString(16)
                    .substring(1);
            }
            return prefix + "_" + rand() + rand() + "-" + rand() + "-" + rand();
        }

        function uuidv4(prefix) {
            const crypto = window.crypto ||
                window.msCrypto || {
                getRandomValues: array => {
                    for (let i = 0, l = array.length; i < l; i++) {
                        array[i] = Math.floor(Math.random() * 256);
                    }
                    return array;
                }
            };
            return prefix + ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
                (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
            )
        }
        checkBotConfigLoaded();

    }

})(jQuery);